import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { Location } from '@angular/common';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent implements OnInit, OnDestroy {
  localTime: string = '';
  utcTime: string = '';
  private timer: any;

  constructor(
    private location: Location,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.updateTimes();
    this.timer = setInterval(() => {
      this.updateTimes();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  private updateTimes(): void {
    const now = new Date();
    this.localTime = now.toLocaleString('th-TH', {
      timeZone: 'Asia/Bangkok',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    this.utcTime = now.toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
  }
  goBack(): void {
    this.location.back()
  }


  goHome(): void {
    this.router.navigate(['/']);
  }
}
